import { SET_LOCALE } from '@/store/types'

/**
 * The plugin synchronizes languages between store and i18n.
 * @param {VueI18n} i18n - Instance of VueI18n
 */
export default function createI18nPlugin(i18n) {
  return (store) => {
    const { locale } = i18n
    store.commit(SET_LOCALE, locale)

    store.subscribe(({ type, payload }) => {
      if (type === SET_LOCALE) {
        // eslint-disable-next-line no-param-reassign
        i18n.setLocale(payload)
      }
    })
  }
}
